import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { formatNumber, type NumberFormatterProps } from '#@/utils/number';

export const useNumberFormatter = () => {
  const { i18n } = useTranslation();

  return useCallback(
    (props: NumberFormatterProps) => formatNumber(i18n.language, props),
    [i18n.language],
  );
};

export const NumberFormatter: React.FC<NumberFormatterProps> = (props) => {
  const format = useNumberFormatter();

  return <>{format(props)}</>;
};
